var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1),_c('AuthDialog',{ref:"AuthDialog"}),_c('OpenNotice',{ref:"OpenNotice"}),_c('GuideDialog',{ref:"GuideDialog",on:{"showGuidePop":_vm.showGuidePop,"showGuideSteps":_vm.showGuideSteps}}),_c('GuideSteps',{ref:"GuideSteps"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }